import 'bootstrap/dist/css/bootstrap.min.css';
import { useContext, useEffect, useState } from "react";
import '../../../App.scss';
import { ApplicationContext } from '../../App';

export default function Campaign() {

   const g_applicationContext = useContext(ApplicationContext);
   const [customerMigrationsByWeek, setCustomerMigrationsByWeek] = useState(null);
  
   useEffect(() => {
      // doStatsLookup();
   }, []);

   return (
      <>
         <h3 style={{ marginBottom: '5rem' }}>Campaigns</h3>
      </>
   );
};
